<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="content-heading">
	<h3>{{locoLabel?.lastReported|uppercase}}</h3>
</div>
<table class="table table-no-border two-col-tbl">
	<tbody>
		<tr>
			<td>{{locoLabel?.lastGps}} {{locoData?.lastReportingSource}}</td>
			<td *ngIf="!returnDash([locoData?.lastReportingCityState,locoData?.lastReportingMilepost,locoData?.lastReportingDateTime])">
				{{locoData?.lastReportingDateTime}} {{(locoData?.lastReportingMilepost || (locoData?.lastReportingCityState && ','!==locoData?.lastReportingCityState.trim()))?
				'@':''}} {{locoData?.lastReportingMilepost}}
				<p>{{','!==locoData?.lastReportingCityState.trim()?locoData?.lastReportingCityState:'-'}}</p>
			</td>
			<td *ngIf="returnDash([locoData?.lastReportingCityState,locoData?.lastReportingMilepost,locoData?.lastReportingDateTime])">-</td>
		</tr>
	</tbody>
</table>
<div class="seperator"></div>
<table class="table table-no-border two-col-tbl">
	<thead>
		<tr>
			<td colspan="2">{{locoLabel?.currentUsage|uppercase}}</td>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>{{locoLabel?.train}}</td>
			<td>{{locoData?.currentUsageTrain|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.terminal}}</td>
			<td>{{locoData?.currentUsageTerminal|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.reportingSource}}</td>
			<td>{{locoData?.currentUsageSource|locoBlankString}}</td>
		</tr>
	</tbody>
</table>
<div class="seperator"></div>
<table class="table table-no-border two-col-tbl">
	<thead>
		<tr>
			<td colspan="2">{{locoLabel?.locationInformation|uppercase}}</td>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>{{locoLabel?.terminal}}</td>
			<td>{{locoData?.bestAvailableLocTerminal|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.reportingType}}</td>
			<td>{{getReportingTypeValue(locoData?.bestAvailableLocType)|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.first}}</td>
			<td>{{locoData?.bestAvailableLocFirstTs|locoBlankString}}</td>
		</tr>
		<tr>
			<td>{{locoLabel?.last}}</td>
			<td>{{locoData?.bestAvailableLocTs|locoBlankString}}</td>
		</tr>
		<tr>
				<td>{{locoLabel?.oprRegion}}</td>
				<td>{{getOprRegion(locoData?.bestAvailableLocTerminal)}}</td>
			</tr>
			<tr>
				<td>{{locoLabel?.oprZone}}</td>
				<td>{{getOprZone(locoData?.bestAvailableLocTerminal)}}</td>
			</tr>
	</tbody>
</table>